module.exports = __webpack_public_path__ + "static/media/mdi_fast_forward.3f50c7aa.svg";